import { ArrowRight } from "lucide-react";
import { fmtDateTime } from "@/lib/api";

const ACTION_CLS = { consumed: "bg-[#5C1D24] text-[#F5F0EB]", sold: "bg-[#2E5D4B] text-[#F5F0EB]", lost: "bg-[#4A3B43] text-[#E5A93C]", in_cellar: "bg-[#1E181B] text-[#D4AF37]" };

export const MovementTable = ({ moves }) => (
  <div className="rounded-xl border border-[#2E252A] overflow-x-auto" data-testid="movement-log-table">
    <table className="w-full text-sm">
      <thead className="bg-[#110D0F] text-left">
        <tr className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#6E665D]">
          <th className="px-4 py-3 font-normal">Date &amp; time</th>
          <th className="px-4 py-3 font-normal">Item</th>
          <th className="px-4 py-3 font-normal">Move</th>
          <th className="px-4 py-3 font-normal hidden sm:table-cell">By</th>
        </tr>
      </thead>
      <tbody>
        {moves.map((m) => (
          <tr key={m.id} className="border-t border-[#2E252A]" data-testid="log-timestamp-row">
            <td className="px-4 py-3 font-mono text-xs text-[#D4AF37] whitespace-nowrap">{fmtDateTime(m.moved_at)}<p className="sm:hidden text-[#6E665D] mt-1">{m.user_name}</p></td>
            <td className="px-4 py-3">
              <p className="font-mono text-xs text-[#F5F0EB]">{m.barcode}</p>
              <p className="text-xs text-[#A89F91]">{m.label}</p>
            </td>
            <td className="px-4 py-3 text-xs text-[#F5F0EB] min-w-[180px]">
              {m.action && m.action !== "move" ? (
                <>
                  <span className="text-[#6E665D]">{m.from_location || "Unassigned"}</span>
                  <ArrowRight className="w-3 h-3 inline mx-2 text-[#D4AF37]" />
                  <span className={`px-2 py-0.5 rounded font-mono text-[10px] uppercase tracking-widest ${ACTION_CLS[m.action] || ""}`} data-testid="log-action-badge">{m.to_location}</span>
                  {m.sale_price != null && <span className="ml-2 font-mono text-[#A89F91]">{m.sale_price.toFixed(2)}</span>}
                  {(m.sale_name || m.sale_box_number) && <p className="text-[#A89F91] mt-1" data-testid="log-sale-info">{[m.sale_name, m.sale_box_number && `box ${m.sale_box_number}`].filter(Boolean).join(" · ")}</p>}
                  {m.note && <p className="text-[#A89F91] mt-1 italic">{m.note}</p>}
                </>
              ) : (
                <>
                  <span className="text-[#6E665D]">{m.from_location || "Unassigned"}</span>
                  <ArrowRight className="w-3 h-3 inline mx-2 text-[#D4AF37]" />
                  {m.to_location}
                </>
              )}
            </td>
            <td className="px-4 py-3 text-xs text-[#A89F91] hidden sm:table-cell">{m.user_name}</td>
          </tr>
        ))}
        {!moves.length && <tr><td colSpan={4} className="px-4 py-10 text-center text-[#6E665D]" data-testid="movement-empty">No movements recorded yet.</td></tr>}
      </tbody>
    </table>
  </div>
);
